import {isEmpty} from 'lodash';
import {
  CategoryList,
  DatasetMetadataLabelItem,
} from '../../types/dataService/DatasetMetadata';
import {ImageDimension} from './types';

export const labelToBoxLabel = (
  label: DatasetMetadataLabelItem,
  image: ImageDimension,
  categories: CategoryList
) => {
  return image && label
    ? {
        x: (label.topLeftX || 0) * image.width,
        y: (label.topLeftY || 0) * image.height,
        width: (label.width || 0) * image.width,
        height: (label.height || 0) * image.height,

        id: label.id,
        label:
          label.category && !isEmpty(categories) ? categories[label.category] : undefined,
        // style?: BoxLabelStyleProps;  - to follow
      }
    : null;
};
